import axios from "axios";

const URL_MANTENEDOR = process.env.VUE_APP_API_MANTENEDOR;

export default {
  obtenerPublicidades(params, dialogo) {
    let visibilidad = 0; //Silder
    if (dialogo) visibilidad = 1; //Dialogo
    return axios.get(URL_MANTENEDOR + `getAdvertisingPortal/${visibilidad}/`, {
      params
    });
  },
  obtenerParametros() {
    return axios.get(URL_MANTENEDOR + `getParamsPortal`);
  }
};
